import { useEffect, useState } from "react"
import axios from "axios"
import "./reset-password.css"

export default function ResetPassword() {
  const params = new URLSearchParams(window.location.search)
  const token = params.get("token")

  const [password, setPassword] = useState("")
  const [confirm, setConfirm] = useState("")
  const [showPassword, setShowPassword] = useState(false)

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState(false)

  const [shake, setShake] = useState(false)
  const [flash, setFlash] = useState(false)

  const rules = {
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*()_+=\-]/.test(password),
  }

  const triggerErrorFX = () => {
    setShake(true)
    setFlash(true)
    setTimeout(() => setShake(false), 400)
    setTimeout(() => setFlash(false), 400)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")

    if (!token) {
      setError("Invalid or expired reset link.")
      triggerErrorFX()
      return
    }

    if (password !== confirm) {
      setError("Passwords do not match.")
      triggerErrorFX()
      return
    }

    if (Object.values(rules).includes(false)) {
      setError("Password does not meet requirements.")
      triggerErrorFX()
      return
    }

    setLoading(true)

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`, {
        token,
        password,
        confirm_password: confirm,
      })

      setSuccess(true)

      setTimeout(() => {
        window.location.href = "/"
      }, 2600)

    } catch (err) {
      setError(
        err.response?.data?.detail ||
        "Reset failed. The link may be expired."
      )
      triggerErrorFX()
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {flash && <div className="flash-overlay" />}

      <div className={`reset-page ${shake ? "shake" : ""}`}>
        <div className="card">
          <h1>Set new password</h1>
          <p className="subtitle">Secure your <strong>LitX</strong> account</p>

          {success ? (
            <div className="success-box">
              <div className="check">✓</div>
              <h2>Password updated</h2>
              <p>Redirecting to login…</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="New password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>

              <ul className="rules">
                {!rules.length && <li>At least 8 characters</li>}
                {!rules.upper && <li>One uppercase letter</li>}
                {!rules.lower && <li>One lowercase letter</li>}
                {!rules.number && <li>One number</li>}
                {!rules.special && <li>One special character</li>}
              </ul>

              <input
                type={showPassword ? "text" : "password"}
                placeholder="Confirm password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />

              <button className="submit" disabled={loading}>
                🔑 {loading ? "Updating…" : "Reset password"}
              </button>
            </form>
          )}

          {error && <p className="error">{error}</p>}

          <div className="watermark">© 2026 LitX.in</div>
        </div>
      </div>
    </>
  )
}